import React from "react";

export default function Footer() {
  return (
    <footer className="footer">
      <p className="has-text-centered">&#169; 2021 Without Care</p>
    </footer>
  );
}
